import audioThumbnail from '@/components/media/audio/audio-thumbnail.vue'
import audioViewer from '@/components/media/audio/audio-viewer.vue'
import imageThumbnail from '@/components/media/image/image-thumbnail.vue'
import imageViewer from '@/components/media/image/image-viewer.vue'
import documentThumbnail from '@/components/media/document/document-thumbnail.vue'
import documentViewer from '@/components/media/document/document-viewer.vue'
import videoThumbnail from '@/components/media/video/video-thumbnail.vue'
import videoViewer from '@/components/media/video/video-viewer.vue'

const install = function(Vue) {
  Vue.component('mct-audio-thumbnail', audioThumbnail)
  Vue.component('mct-audio-viewer', audioViewer)

  Vue.component('mct-image-thumbnail', imageThumbnail)
  Vue.component('mct-image-viewer', imageViewer)

  Vue.component('mct-document-thumbnail', documentThumbnail)
  Vue.component('mct-document-viewer', documentViewer)

  Vue.component('mct-video-thumbnail', videoThumbnail)
  Vue.component('mct-video-viewer', videoViewer)
}

export default { install }
